declare global {
  interface Window {
    electron: any;
  }
}

import Vue from "vue";
import { BootstrapVue, BootstrapVueIcons, IconsPlugin } from "bootstrap-vue";
import linkify from "vue-linkify";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-vue/dist/bootstrap-vue.min.css";

import { LoggerService as lgg } from "vue-components-library";
import { ComponentErrorHandler } from "@/App/services/ComponentErrorHandler";
import { name as projectName, version } from "../package.json";

lgg.init({
  datadog: { clientToken: process.env.VUE_APP_DATADOG_CLIENT_TOKEN || "" },
  env: process.env.VUE_APP_TARGET_ENVIRONMENT,
  project: window.electron ? "ems-electron" : projectName,
  version,
});

import router from "@/App/router";
import store from "@/App/store";
import App from "@/App/ui/App.vue";
import "@/App/services/RegisterServiceWorker";

Vue.config.productionTip = false;
Vue.config.errorHandler = ComponentErrorHandler;

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(BootstrapVueIcons);

Vue.directive("linkified", linkify);

new Vue({
  router,
  store,
  /* created() {
    // Prevent blank screen in Electron builds
    this.$router.push("/");
  }, */
  render: (h) => h(App),
}).$mount("#app");
